import { ApiError } from '../../api/client';
import { errorMessage } from '../../lib/notify';

/** Clear wording for the admin-account errors (M19 contract); anything else falls back to the API message. */
const MESSAGES: Record<string, string> = {
  EMAIL_TAKEN: 'A platform admin with this email already exists.',
  SELF_DEACTIVATION: 'You can’t deactivate your own account. Ask another super admin to do it.',
  LAST_SUPER_ADMIN:
    'At least one active super admin must remain. Make someone else a super admin first.',
  VERSION_CONFLICT:
    'Someone else changed this admin a moment ago. The list has been refreshed — check it and try again.',
  NOT_FOUND: 'This admin no longer exists. The list has been refreshed.',
};

export function adminErrorMessage(error: unknown): string {
  if (error instanceof ApiError && error.code in MESSAGES) return MESSAGES[error.code] ?? '';
  return errorMessage(error);
}
